module.exports = __webpack_public_path__ + "img/error.d1a260dc.png";